/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import {IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { IProductListContainerData } from './product-list-container.data';
import { IProductListContainerProps } from './product-list-container.props.autogenerated';
import * as Msdyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';

export interface IProductListContainerViewProps extends IProductListContainerProps<IProductListContainerData> {
    categoryName:React.ReactNode;
    categoryCopy:React.ReactNode;
    className?:string;
    message:React.ReactNode;
    contents:React.ReactNode[];
    productListContainer:IModuleProps;
    productListDetailsContainer:INodeProps;
    productListItem:INodeProps;
}

/**
 *
 * ProductListContainer component
 * @extends {React.PureComponent<IProductListContainerProps<IProductListContainerData>>}
 */
class ProductListContainer extends React.PureComponent<IProductListContainerProps<IProductListContainerData>> {
    
    public render(): JSX.Element | null {
        const{
            categoryName,
            categoryCopy,
            className,
            message
        }=this.props.config;
        const categoryNameText=categoryName&&(
            <Msdyn365.Text
                className='product-list-container__name'
                text={categoryName}
                tag={'h1'}
            />
        );
        const categoryCopyText=categoryCopy&&(
            <Msdyn365.RichTextComponent
                className='product-list-container__description'
                text={categoryCopy}
                />
        );
        const messageText=message&&(
            <Msdyn365.RichTextComponent
                className='product-list-container__message'
                text={message}
                />
        );
        const ProductListContainerViewProps={
            ...this.props,
            categoryName:categoryNameText,
            categoryCopy:categoryCopyText,
            message:messageText,
            moduleClass:this.props.config.className,
            productListContainer:{
                moduleProps:this.props,
                className:classnames('product-list-container',className),
            },
            contents:this.props.slots.productListBlock,
            productListDetailsContainer:{className:'product-list-container__details'},
            productListItem:{className:'product-list-container__item'},
        };
        return this.props.renderView(ProductListContainerViewProps) as React.ReactElement;
    }
}

export default ProductListContainer;
